import { mutateGraphQL } from '~/hooks/graphql.js';
import { getCartItemNode, getCartNode } from '~/hooks/queries/use-cart-data-query.js';

/**
 * addToCartMutation
 *
 * productId, quantity
 * 
 */
const addToCartMutation = `
  mutation AddToCartMutation($productId: Int!, $quantity: Int!) {
		addToCart(input: { productId: $productId, quantity: $quantity }) {
			${ getCartItemNode }
      ${ getCartNode }
		}
	}
`;

/**
 * addCartItemsMutation
 *
 * items: CartItemInput [productId, quantity]
 *
 */
const addCartItemsMutation = `
  mutation addCartItems($cartItemsInput: [CartItemInput]) {
		addCartItems(input: { items: $cartItemsInput }) {
      ${ getCartNode }
		}
	}
`;

/**
 * UpdateItemQuantitiesMutation
 *
 * CartItemQuantityInput:[ { key, quantity } ]
 */
const updateItemQuantitiesMutation =  `
  mutation UpdateItemQuantities($cartItemQuantityInput: [CartItemQuantityInput]) {
    updateItemQuantities(input: { items: $cartItemQuantityInput }) {
      updated {
        key
        quantity
        relativeSingleUnitPrice
        product {
          node {
            productId
          }
        }
      }
      ${ getCartNode }
    }
  }
`;

/**
 * removeItemsFromCartMutation
 *
 * cartItemKeys: Array, removeAll: Boolean
 */
const removeItemsFromCartMutation = `
  mutation RemoveItemsFromCart($cartItemKeys: [ID], $removeAll: Boolean) {
    removeItemsFromCart(input: { keys: $cartItemKeys, all: $removeAll }) {
      ${ getCartNode }
    }
}
`;

/**
 * applyCouponMutation
 *
 * couponCode
 *
 */
const applyCouponMutation = `
  mutation ApplyCoupon($code: String!) {
    applyCoupon(input: { code: $code }) {
      clientMutationId
      applied {
          code
          discountAmount
      }
      ${ getCartNode }
    }
  }
`;

/**
 * removeCouponsMutation
 *
 * codes: [couponCode]
 *
 */
const removeCouponsMutation = `
  mutation RemoveCoupons($couponCodes: [String!]) {
    removeCoupons(input: { codes: $couponCodes }) {
      ${ getCartNode }
    }
  }
`;

/**
 * mutateGraphQL returns a callback method.
 */
export const getCartMutationHandler = (eventType) => {
	let mutation;
  switch (eventType) {
    case 'addToCart':
      mutation = addToCartMutation;
      break;
    case 'addCartItems':
      mutation = addCartItemsMutation;
      break;
    case 'applyCoupon':
      mutation = applyCouponMutation;
      break;
    case 'removeCoupons':
      mutation = removeCouponsMutation;
      break;
    case 'UpdateItemQuantities':
      mutation = updateItemQuantitiesMutation;
      break;
    case 'removeItemsFromCart':
      mutation = removeItemsFromCartMutation;
  }

  if (mutation) {
    const { mutationHandler } = mutateGraphQL(mutation);

    return { mutationHandler };
  }

  return null;
}
